import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5515_15122)">
      <mask
        id="mask0_5515_15122"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <path d="M24 0.607666H0V24.6077H24V0.607666Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5515_15122)">
        <path
          d="M12 24.6077C5.37277 24.6077 0 19.2349 0 12.6077C0 5.98044 5.37277 0.607666 12 0.607666C18.6273 0.607666 24 5.98044 24 12.6077C24 19.2349 18.6285 24.6077 12 24.6077Z"
          fill="black"
        />
        <path
          d="M5.25391 18.7681V14.6769L13.4835 6.44727H18.7463V18.7681H13.4835V14.4312L9.14667 18.7681H5.25391Z"
          fill="#FFFDFD"
        />
        <path
          d="M5.25391 10.7558V6.44727H12.0946L7.7861 10.7558H5.25391Z"
          fill="#ED3E7D"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5515_15122">
        <rect y="0.607666" width="24" height="24" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
